import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import PageHome from '../pages/PageHome/PageHome';
import PageTradeshowManagement from '../pages/PageTradeshowManagement/PageTradeshowManagement';
import PageExhibitManagement from '../pages/PageExhibitManagement/PageExhibitManagement';
import PageDisplays from '../pages/PageDisplays/PageDisplays';
import PageCustomFabrication from '../pages/PageCustomFabrication/PageCustomFabrication';
import PageAccessories from '../pages/PageAccessories/PageAccessories';
import PageDesign from '../pages/PageDesign/PageDesign';
import PageContact from '../pages/PageContact/PageContact';
import PageThankyou from '../pages/PageThankyou/PageThankyou';
import PageEnvironment from '../pages/PageEnvironment/PageEnvironment';
import PageNotFound from '../pages/PageNotFound/PageNotFound';

import './App.css';

class App extends Component {

  render() {
    return (
      <Router>
          <Switch>
            <Route exact path="/" component={(routeProps, state, params) => <PageHome page="Home" />}/>
            <Route exact path="/services" component={(routeProps, state, params) => <PageTradeshowManagement page="TradeshowManagement" />}/>
            <Route exact path="/services/tradeshow_management" component={(routeProps, state, params) => <PageTradeshowManagement page="TradeshowManagement" />}/>
            <Route exact path="/services/exhibit_management" component={(routeProps, state, params) => <PageExhibitManagement page="ExhibitManagement" />}/>
            <Route exact path="/displays" component={(routeProps, state, params) => <PageDisplays page="Displays" />}/>
            <Route exact path="/displays/displays" component={(routeProps, state, params) => <PageDisplays page="Displays" />}/>
            <Route exact path="/displays/custom_fabrication" component={(routeProps, state, params) => <PageCustomFabrication page="CustomFabrication" />}/>
            <Route exact path="/accessories" component={(routeProps, state, params) => <PageAccessories page="Accessories" />}/>
            <Route exact path="/design" component={(routeProps, state, params) => <PageDesign page="Design" />}/>
            <Route exact path="/contact" component={(routeProps, state, params) => <PageContact page="Contact" />}/>
            <Route exact path="/thankyou" component={(routeProps, state, params) => <PageThankyou page="Thankyou" />}/>
            <Route exact path="/environment" component={(routeProps, state, params) => <PageEnvironment page="Environment" />}/>
            <Route component={PageNotFound}/>
          </Switch>
          
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js